import axios from "axios";

export default class EspecialidadesService {
  allEspecialidades() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "especialidades/todas");
  }
  crearEspecialidad(data) {
    return axios.post(
      process.env.VUE_APP_API_PUBLIC + "especialidades/create",
      data
    );
  }
  editarEspecialidad(data) {
    return axios.put(
      process.env.VUE_APP_API_PUBLIC + "especialidades/update",
      data
    );
  }
  eliminarEspecialidad(data) {
    return axios.delete(
      process.env.VUE_APP_API_PUBLIC + "especialidades/delete",
      {
        data: data,
      }
    );
  }
  toggleEnListado(data) {
    return axios.put(
      process.env.VUE_APP_API_PUBLIC + "especialidades/toggle",
      data
    );
  }
}
